import React from "react";

import { ReactComponent as ExternalLinkRedirectIcon } from "assets/svgs/external-link-icon.svg";

import * as S from "./SectionTextBlock.Style";

const SectionTextBlock = ({
  title,
  subtitle,
  description,
  link,
  linkText,
  border,
}) => {
  return (
    <S.SectionTextBlockContent $border={Boolean(border)}>
      <S.SectionTextBlockHeader>
        <S.SectionTextBlockTitle>{title}</S.SectionTextBlockTitle>

        {subtitle && (
          <S.SectionBlockSubTitle>{subtitle}</S.SectionBlockSubTitle>
        )}
      </S.SectionTextBlockHeader>

      <S.SectionTextBlockDescription>
        {description}
      </S.SectionTextBlockDescription>

      {link && (
        <S.SectionTextBlockContentLink>
          <S.SectionTextBlockLink href={link} target="_blank">
            {linkText}
          </S.SectionTextBlockLink>
          <ExternalLinkRedirectIcon />
        </S.SectionTextBlockContentLink>
      )}
    </S.SectionTextBlockContent>
  );
};

export default SectionTextBlock;
